import { type ReactNode, useId, useState } from "react";

type FinanceFilterPanelProps = {
  additional?: ReactNode;
  additionalFilterCount?: number;
  hasActiveFilters?: boolean;
  onClear?: () => void;
  primary: ReactNode;
};

export default function FinanceFilterPanel({
  additional,
  additionalFilterCount = 0,
  hasActiveFilters = false,
  onClear,
  primary,
}: FinanceFilterPanelProps) {
  const [expanded, setExpanded] = useState(false);
  const additionalFiltersId = useId();
  const hasAdditionalFilters = additional !== undefined && additional !== null;

  return (
    <div className="border-b border-slate-200 bg-slate-50 p-4">
      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-5">{primary}</div>

      {(hasAdditionalFilters || (hasActiveFilters && onClear)) && (
        <div className="mt-3 flex flex-wrap items-center gap-3">
          {hasAdditionalFilters && (
            <button
              aria-controls={additionalFiltersId}
              aria-expanded={expanded}
              className="text-sm font-semibold text-emerald-700 hover:text-emerald-800"
              type="button"
              onClick={() => setExpanded((current) => !current)}
            >
              {expanded ? "Fewer filters" : "More filters"}
              {additionalFilterCount > 0 ? ` (${additionalFilterCount})` : ""}
            </button>
          )}
          {hasActiveFilters && onClear && (
            <button
              className="text-sm font-medium text-slate-600 hover:text-slate-900"
              type="button"
              onClick={onClear}
            >
              Clear all filters
            </button>
          )}
        </div>
      )}

      {hasAdditionalFilters && expanded && (
        <div
          id={additionalFiltersId}
          className="mt-3 grid gap-3 border-t border-slate-200 pt-3 sm:grid-cols-2 xl:grid-cols-5"
        >
          {additional}
        </div>
      )}
    </div>
  );
}
